import { EngagementForInsightCheck } from '@anytag/graphql';
import { TableV2 } from '@anytag/shared-atoms';
import { TableData } from '@anytag/shared-types';
import { usePostsInsightListTable } from './hooks';

export type PostsInsightListProps = TableData<EngagementForInsightCheck>;

export const PostsInsightList = ({ loading, data = [] }: PostsInsightListProps) => {
  const { columns } = usePostsInsightListTable();

  return <TableV2 loading={loading} hasBorder={false} data={data} columns={columns} noTopBorderRadius />;
};
